import React, { useEffect, useState } from "react";
import "../style/agent.css";
import qualityListings from "../images/agent/QualityListings.svg";
import badgeResponsive from "../images/agent/BadgeResponsive.svg";
import dummyPerson from "../images/dummy_person.png";
import { Link, useNavigate } from "react-router-dom";
import { API_Path, imgBaseUrl } from "../Const";
import { PostApi } from "../api/api-service";
import EmailAgentModal from "../components/modal/EmailAgentModal";
import AgentFilter from "../components/filter/AgentFilter";
import ContectModal from "../components/modal/ContectModal";
import TruAgentModal from "../components/modal/TruAgentModal";
import QualityLister from "../components/modal/QualityLister";
import ResponsiveBrokerModal from "../components/modal/ResponsiveBrokerModal";
import noDataFound from "../images/noDataFound.png";
import NewCommonPagination from "../components/NewCommonPagination";
import AgentLoader from "../components/loader/AgentLoader";
import developerLogo from "../images/developer.svg";
import { RiMedal2Fill } from "react-icons/ri";
import { REMail, RETelephone, REWhatsapp } from "../components/icons/IconSvg";
function AgentList() {
    const navigate = useNavigate();
    const [isLoader, setIsLoader] = useState(false);
    const [agentData, setAgentData] = useState([]);
    const [emailMdlShow, setEmailMdlShow] = useState(false);
    const [pageSize, setPageSize] = useState(20);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [phoneModalShow, setPhoneModalShow] = useState({ show: false, data: "" });
    const [qualityShow, setQualityShow] = useState(false);
    const [truAgentShow, setTruAgentShow] = useState(false);
    const [resAgentShow, setResAgentShow] = useState(false);
    const [agentFilter, setAgentFilter] = useState({ type: "Agent", name: [], languages: [], contacts: [], specialities: "", country: "", state: "", city: "", locality: "", searchValue: "" });
    const [btnLoader, setBtnLoader] = useState({ serach: false, reset: false });

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const parsedFilters = {
            type: "Agent",
            name: params.get("name")?.split(",") || [],
            languages: params.get("languages")?.split(",") || [],
            specialities: params.get("specialities") || "",
            searchValue: params.get("searchValue") || "",
            city: params.get("city") || "",
            currentPageA: params.get("page") || 1,
        };
        setAgentFilter(parsedFilters);
        fetchAgentData(parsedFilters?.currentPageA, parsedFilters);
    }, []);

    const handleModalHide = () => setEmailMdlShow(false);
    const fetchAgentData = async (page, item) => {
        let data = {
            name: item?.name?.length > 0 ? item?.name : null,
            languages: item?.languages?.length > 0 ? item?.languages : null,
            contacts: item?.contacts?.length > 0 ? item?.contacts : null,
            specialities: item?.specialities ? item?.specialities : null,
            country: item?.country ? item?.country : null,
            state: item?.state ? item?.state : null,
            city: item?.city ? item?.city : null,
            locality: item?.locality ? item?.locality : null,
            searchValue: item?.searchValue ? item?.searchValue : null,
        };
        let cleanedData = Object.fromEntries(Object.entries(data).filter(([key, value]) => value !== null && value !== undefined && value !== "" && value !== 0 && !(Array.isArray(value) && value.length === 0)));
        try {
            setIsLoader(true);
            let res = await PostApi(API_Path.agentDetails + `/pagination?pageNumber=${page}&pageSize=${pageSize}`, { data: cleanedData });
            if (res && res.data.success) {
                setAgentData(res.data.data);
                setCurrentPage(res.data.currentPage);
                setPageSize(res.data.pageSize);
                setTotalPages(res.data.totalPages);
            }
            setBtnLoader({ serach: false, reset: false });
            setIsLoader(false);
        } catch (error) {
            setBtnLoader({ serach: false, reset: false });
            setIsLoader(false);
        }
    };
    const tableCallBack = (page) => {
        fetchAgentData(page, agentFilter);
    };
    const handlePhoneModalHide = () => setPhoneModalShow({ ...phoneModalShow, show: false });
    const filterCallBack = (option) => setAgentFilter(option);
    const handlewhatsapp = (e) => {
        e.stopPropagation();
        e.preventDefault();
        window.open("https://web.whatsapp.com");
    };
    const handleTruAgentShow = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setTruAgentShow(true);
    };
    const handleQualityShow = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setQualityShow(true);
    };
    const handleResAgentShow = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setResAgentShow(true);
    };
    const handleTruAgentClose = () => setTruAgentShow(false);
    const handleQualityClose = () => setQualityShow(false);
    const handleResAgentClose = () => setResAgentShow(false);
    const handlesearch = () => {
        navigate(buildSearchUrl());
        setBtnLoader({ serach: true, reset: false });
        fetchAgentData(1, agentFilter);
    };
    const handleReset = () => {
        setBtnLoader({ serach: false, reset: true });
        navigate("/agents");
        let data = { type: "Agent", name: [], languages: [], contacts: [], specialities: "", country: "", state: "", city: "", locality: "", searchValue: "" };
        // let url = "/agents";
        // url += encodeURIComponent()
        setAgentFilter(data);
        fetchAgentData(1, data);
    };
    const loaders = Array.from({ length: 6 });
    const buildSearchUrl = () => {
        let url = "/agents/search";
        let first = true;
        const add = (key, value) => {
            if (!value || (Array.isArray(value) && value.length === 0)) return;
            url += `${first ? "?" : "&"}${key}=${encodeURIComponent(Array.isArray(value) ? value.join(",") : value)}`;
            first = false;
        };
        add("name", agentFilter.name);
        add("languages", agentFilter.languages);
        add("specialities", agentFilter.specialities);
        add("searchValue", agentFilter.searchValue);
        add("city", agentFilter.city);
        return url;
    };
    const isFilterActive = () => {
        return agentFilter.searchValue || agentFilter.specialities || agentFilter.city || (agentFilter.name && agentFilter.name.length > 0) || (agentFilter.languages && agentFilter.languages.length > 0) || (agentFilter.contacts && agentFilter.contacts.length > 0);
    };

    return (
        <>
            <div className="property-dropdown area-slider-sec">
                <div className="container">
                    <div className="agent_card_flex">
                        <div className="agent_card_left">
                            <h2>Find the right agent</h2>
                            <p>Connect with trusted real estate agents in your area</p>
                        </div>
                        <div className="agent_card_rigth">
                            <div className="hero-dropdown-sec px-3">
                                <div className="agent-main-dropdown agent-dropdown">
                                    <AgentFilter name="agent" filterData={agentFilter} filterCallBack={filterCallBack} data={agentData} />
                                    <div>
                                        {isFilterActive() && (
                                            <button className="button reset_btn me-2" onClick={handleReset} disabled={btnLoader.reset}>
                                                Reset
                                            </button>
                                        )}
                                        <button className="button search_btn" onClick={handlesearch}  disabled={btnLoader.serach || !isFilterActive()}>
                                            Search
                                            {btnLoader.serach && <span className="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>}
                                        </button>
                                    </div>
                                </div>
                                {/* {(agentFilter.searchValue || agentFilter.specialities || agentFilter.name?.length > 0 ||agentFilter.languages?.length > 0 ) && ( */}

                                {/* )} */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="agent-profile-sec">
                <div className="container">
                    {isLoader ? (
                        <div className="agent-profile-inner">
                            <div className="row">
                                {loaders.map((_, index) => (
                                    <div className="col-lg-6 col-md-12" key={index}>
                                        <div className="agent-card-details">
                                            <div className="agent-card">
                                                <AgentLoader />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <>
                            {agentFilter.type === "Agent" &&
                                (agentData.length > 0 ? (
                                    <>
                                        <div className="agent-profile-inner">
                                            <div className="row">
                                                {agentData.map((item, i) => (
                                                    <div className="col-lg-6 col-md-12" key={i}>
                                                        <div className="agent-card-details">
                                                            <div className="agent-card position-relative">
                                                                <Link to={`/agent-details/${item?.slug}_${item?.uId}`} className="link_anchor"></Link>
                                                                    <div className="agent-card-inner agent_card_inner p-10">
                                                                        <div className="card_img agent_card_img">
                                                                            <img
                                                                                src={item.path ? imgBaseUrl + item.path : dummyPerson}
                                                                                alt={item.name}
                                                                                onError={({ currentTarget }) => {
                                                                                    currentTarget.onerror = null;
                                                                                    currentTarget.src = `${dummyPerson}`;
                                                                                }}
                                                                                loading="lazy"
                                                                            />
                                                                            {item?.rating && item?.rating !== 0 && <div className="agent_label">{(parseInt(item?.rating) === 4 || parseInt(item?.rating) === 5) && <p className="signature">Signature</p>}</div>}
                                                                        </div>
                                                                        <div className="agent_card_content agent_title">
                                                                            {/* {item?.rating && item?.rating !== 0 && <div className="agent_label">{(parseInt(item?.rating) === 4 || parseInt(item?.rating) === 5) && <p className="signature">Signature</p>}</div>} */}
                                                                            <h1 className="agent_name mb-1">{item.name}</h1>
                                                                            <p className="broker_name">{item?.agency?.name}</p>
                                                                            {(item?.isTopAgent || item?.isQualityLister || item?.isHighlyResponsive) && (
                                                                                <div className="top_agent">
                                                                                    {item?.isTopAgent && (
                                                                                        <div>
                                                                                            <button className="tru_btn" onClick={(e) => handleTruAgentShow(e)}>
                                                                                                <RiMedal2Fill color="#28b16d" />
                                                                                                Tru<b>Agent</b>
                                                                                                <span>™</span>
                                                                                            </button>
                                                                                        </div>
                                                                                    )}
                                                                                    {item?.isQualityLister && (
                                                                                        <div>
                                                                                            <button className="tru_btn lister_btn" onClick={(e) => handleQualityShow(e)}>
                                                                                                <div>
                                                                                                    <img src={qualityListings} alt="Quality Lister" />
                                                                                                </div>
                                                                                                <b>Quality Lister</b>
                                                                                            </button>
                                                                                        </div>
                                                                                    )}
                                                                                    {item?.isHighlyResponsive && (
                                                                                        <div>
                                                                                            <button className="tru_btn res_btn" onClick={(e) => handleResAgentShow(e)}>
                                                                                                <div>
                                                                                                    <img src={badgeResponsive} alt="Responsive Broker" />
                                                                                                </div>
                                                                                                <b>Responsive Broker</b>
                                                                                            </button>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                            {item?.agentStats?.propertyCount && (
                                                                                <div className="agent-details">
                                                                                    <p>Properties : </p>
                                                                                    <span>{item?.agentStats?.propertyCount ? item?.agentStats?.propertyCount : 0}</span>
                                                                                </div>
                                                                            )}
                                                                            {item?.agentLanguages.length <= 0 && item.languages && (
                                                                                <div className="agent-details feature_value">
                                                                                    <p>Language : </p>
                                                                                    <span className="text-capitalize">{item.languages}</span>
                                                                                </div>
                                                                            )}
                                                                            {item?.agentLanguages && item?.agentLanguages.length > 0 && (
                                                                                <div className="agent-details feature_value">
                                                                                    <p>Language : </p>
                                                                                    <span className="text-capitalize">
                                                                                        {item?.agentLanguages
                                                                                            .map((data) => data.languageType)
                                                                                            .join(", ")
                                                                                            .replace(/, ([^,]*)$/, " & $1")}
                                                                                    </span>
                                                                                </div>
                                                                            )}
                                                                            <div className="agent-actions">
                                                                                {item?.contactMethods?.email && (
                                                                                    <div
                                                                                        className="agent-actions-btn mail_btn"
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            e.preventDefault();
                                                                                            setEmailMdlShow(true);
                                                                                        }}
                                                                                    >
                                                                                        {/* <TbMailFilled /> */}
                                                                                        <REMail />
                                                                                    </div>
                                                                                )}
                                                                                {item?.contactMethods?.call && (
                                                                                    <div
                                                                                        className="agent-actions-btn mail_btn"
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            e.preventDefault();
                                                                                            setPhoneModalShow({ show: true, data: item });
                                                                                        }}
                                                                                    >
                                                                                        {/* <MdPhone /> */}
                                                                                        <RETelephone />
                                                                                    </div>
                                                                                )}
                                                                                {/* {item?.contactMethods?.whatsApp && (
                                                                                    <button className="agent-actions-btn mail_btn" onClick={handlewhatsapp} aria-label="Whatsapp">
                                                                                        <RiWhatsappFill />
                                                                                        <REWhatsapp />
                                                                                        <span className="whatsapp-btn">WhatsApp</span>
                                                                                    </button>
                                                                                )} */}
                                                                                {item?.contactMethods?.whatsApp && (
                                                                                    <div className="wp-btn wp-size">

                                                                                    <button className="button" onClick={handlewhatsapp} aria-label="Whatsapp">
                                                                                        {/* <RiWhatsappFill /> */}
                                                                                        <REWhatsapp />
                                                                                        {/* <span className="whatsapp-btn">WhatsApp</span> */}
                                                                                    </button>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        {item?.agency && item?.agency?.logoPath && (
                                                                            <Link to={`/agencies/${item?.agency?.slug}_${item?.agency?.uId}`}>
                                                                                <div className="agency_logo">
                                                                                    <img
                                                                                        src={imgBaseUrl + item?.agency?.logoPath}
                                                                                        alt={item?.agency?.name}
                                                                                        onError={({ currentTarget }) => {
                                                                                            currentTarget.onerror = null;
                                                                                            currentTarget.src = `${developerLogo}`;
                                                                                        }}
                                                                                        loading="lazy"
                                                                                    />
                                                                                </div>
                                                                            </Link>
                                                                        )}
                                                                    </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <NewCommonPagination currentPage={currentPage} pageSize={pageSize} totalPages={totalPages} tableCallBack={tableCallBack} data={buildSearchUrl()} />
                                    </>
                                ) : (
                                    <div className="content_notfound">
                                        <img src={noDataFound} alt="No results matching your search" />
                                        <h3>No results matching your search.</h3>
                                        {/* <p>You could try to remove some filters.</p> */}
                                    </div>
                                ))}
                        </>
                    )}
                </div>
            </div>
            {emailMdlShow && <EmailAgentModal show={emailMdlShow} onHide={handleModalHide} type="agents" />}
            {phoneModalShow.show && <ContectModal show={phoneModalShow.show} onHide={handlePhoneModalHide} data={phoneModalShow.data} />}
            {truAgentShow && <TruAgentModal show={truAgentShow} onHide={handleTruAgentClose} />}
            {qualityShow && <QualityLister show={qualityShow} onHide={handleQualityClose} />}
            {resAgentShow && <ResponsiveBrokerModal show={resAgentShow} onHide={handleResAgentClose} />}
        </>
    );
}

export default AgentList;
